import { useToast } from "@/hooks/use-toast";
import type { ToastActionElement } from "@/components/ui/toast";

type ToastProps = {
  title?: string;
  description?: string;
  action?: ToastActionElement;
};

export function useEnhancedToast() {
  const { toast, success, error, warning, info, dismiss, toasts } = useToast();

  return {
    toast,
    success: (options: ToastProps = {}) =>
      success({
        title: options.title ?? "Success",
        description: options.description,
        action: options.action,
      }),
    error: (options: ToastProps = {}) =>
      error({
        title: options.title ?? "Error",
        description: options.description,
        action: options.action,
      }),
    warning: (options: ToastProps = {}) =>
      warning({
        title: options.title ?? "Warning",
        description: options.description,
        action: options.action,
      }),
    info: (options: ToastProps = {}) =>
      info({
        title: options.title ?? "Info",
        description: options.description,
        action: options.action,
      }),
    dismiss,
    toasts,
  };
}
